import * as React from "react";
import Modal from "antd/lib/modal/Modal";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { Button, Transfer } from "antd";

export interface State {}

export interface Props {
  modalVisible: boolean;
  translate: TTranslate;
  onChangeModalVisible: any;
  indexTypes;
  currentGroupItems: any;
  assignItems: any;
  finishAssigningItems: any;
  onChangeCreateItemModalVisible;
  createItem;
}

export default class TransferListGroupItemModal extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      modalVisible,
      translate,
      onChangeModalVisible,
      indexTypes,
      currentGroupItems,
      assignItems,
      finishAssigningItems,
      onChangeCreateItemModalVisible
    } = this.props;

    return (
      <Modal
        visible={modalVisible}
        title={translate("editors.index_type_groups.transfer_items.title")}
        okText={translate("data_grid.modal.actions.accept")}
        cancelText={translate("data_grid.modal.actions.cancel")}
        onCancel={() => onChangeModalVisible(false, null)}
        onOk={() => finishAssigningItems()}
        closable={true}
        maskClosable={true}
        bodyStyle={{ paddingTop: 12, textAlign: "right" }}
      >
        <Button
          type={"primary"}
          size={"small"}
          style={{ marginBottom: 15 }}
          onClick={onChangeCreateItemModalVisible}
        >
          {translate(
            "editors.index_type_groups.transfer_items.add_new_index_data"
          )}
        </Button>
        <Transfer
          showSearch={true}
          rowKey={(record) => record.id}
          dataSource={indexTypes}
          targetKeys={currentGroupItems}
          render={(item) => item.name}
          onChange={(targetKeys) => assignItems(targetKeys)}
          locale={{
            notFoundContent: translate("search.no_data"),
            searchPlaceholder: translate(
              "editors.index_type_groups.transfer_items.search"
            )
          }}
          className={"png-transfer"}
        />
      </Modal>
    );
  }
}
